import request from '@/utils/request'

const getProductName = () => {
    return request({
        url: '/api/backend/product/getProductName',
        method: 'get'
    })
}

const getSnapData = (form) => {
    return request({
        url: '/api/backend/product/getSnapData',
        method: 'post',
        params: form
    })
}

export default {
    getProductName,
    getSnapData
}